const mEditionBillingMyPaymentsCancelVenta = {
  mEditionBillingMyPaymentsCancelVenta: {
    alerts: {
      updateVenta: {
        error: 'Un error ha ocurrido. Verifica que la sucripción este activa.',
        success: 'Se canceló en forma exitosamente la suscripción.',
        successGateway: 'Solicitud de cancelación exitosa. Deberás esperar la confirmación de la pasarela de pago.'
      }
    }
  }
}

export default mEditionBillingMyPaymentsCancelVenta
